import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { CalAngularModule, CalAngularService } from '@cvx/cal-angular';
import { environment } from '../environments/environment';
import { httpInterceptor } from './core/interceptor/http.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([httpInterceptor])),

    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    
    CalAngularService,
    importProvidersFrom([
      CalAngularModule.forRoot(environment.calSettings)
    ]),
  ]
};
